<script lang="ts" module>
	export interface AddToCartProps {
		icon?: 'leading' | 'trailing';
		size?: ButtonSize;
		disabled?: boolean | null | undefined;
		productId: string | null | undefined;
		cartItem: Omit<CartItem, 'quantity'>;
		dataCy: string;
		quantity?: number;
		children?: import('svelte').Snippet;
		class?: string;
	}
</script>

<script lang="ts">
	import classNames from 'classnames';
	import { twMerge } from 'tailwind-merge';
	import type { CartItem } from '../../utils/createCartItemsStore';
	import { getCheckoutContext } from '../../utils/getCheckoutContext';
	import { browser } from '$app/env';
	import { CartIcon } from '$global/assets/icons/CartIcon';
	import { TickIcon } from '$global/assets/icons/TickIcon';
	import { Button, type ButtonSize } from '$global/components/Button';

	let {
		icon,
		dataCy,
		productId,
		cartItem,
		quantity = 1,
		children,
		...rest
	}: AddToCartProps = $props();

	const {
		cartItems: { addToCart, animated, added },
		mixpanelEvents,
	} = getCheckoutContext();

	let buttonProps = $derived({
		dataCy: `${dataCy}-add-to-cart`,
		loading: $animated === productId,
		size: 'md' as ButtonSize,
		icon: true,
		...rest,
		class: twMerge('min-w-[12.5rem]', rest.class),
	});

	let onClick = $derived(() => {
		if (browser && !$animated && !$added) {
			addToCart(productId, cartItem, quantity, mixpanelEvents);
		}
	});
</script>

{#if productId}
	{#if $added === productId}
		<Button {...buttonProps} onclick={onClick}>
			{#snippet trailing()}
				<TickIcon />
			{/snippet}
			Added to cart
		</Button>
	{:else if icon === 'leading'}
		<Button {...buttonProps} onclick={onClick}>
			{#snippet leading()}
				<CartIcon class={classNames({ hidden: $animated === productId })} />
			{/snippet}
			{@render children?.()}
		</Button>
	{:else}
		<Button {...buttonProps} onclick={onClick}>
			{#snippet trailing()}
				<CartIcon class={classNames({ hidden: $animated === productId })} />
			{/snippet}
			{@render children?.()}
		</Button>
	{/if}
{/if}
